import React, { useEffect, useState } from "react";
import DealService from "../Services/DealService";
import { Timeline } from "primereact/timeline";
import { FaChevronLeft } from "react-icons/fa";

const DealNotesHistory = ({
  handleDealNotesHistoryBack,
  isHide = false,
  dealId,
}) => {
  const [events, setEvents] = useState([]);
  const fetchDealNotesHistory = async () => {
    try {
      const body = { dealId: dealId };
      const response = await DealService.dealNotesHistory(body);
      const data = response.data;
      const formattedEvents = data.map((item) => ({
        timestamp: item?.timestamp,
        log: item.log,
        user: item.addedBy,
      }));
      setEvents(formattedEvents);
    } catch (error) {
      console.error("Error fetching deal notes history:", error);
    }
  };
  useEffect(() => {
    fetchDealNotesHistory();
  }, []);
  return (
    <div>
      {isHide && (
        <div className="flex items-center gap-3 ">
          <button
            onClick={handleDealNotesHistoryBack}
            className="text-2xl text-gray-600 hover:text-gray-800"
          >
            <FaChevronLeft className="text-customGreen " />
          </button>
          <h2 className="text-lg font-semibold">Deal Notes History</h2>
        </div>
      )}
      <div>
        <Timeline
          className=" mt-10 "
          value={events}
          opposite={(item) => (
            <small className="text-color-secondary text-[12px] font-semibold w-full xl:text-[12px] whitespace-nowrap">
              {item.timestamp}
            </small>
          )}
          content={(item) => (
            <div className="flex flex-col gap-1">
              <small className="text-color-secondary text-[13px] font-semibold xl:text-[12px] w-full">
                {item.log}
              </small>
              {item.user && (
                <small className="text-color-secondary text-[12px] font-semibold xl:text-[12px] w-full">
                  added by : {item.user}
                </small>
              )}
            </div>
          )}
          marker={(item) => (
            <span
              className="custom-marker"
              style={{ borderColor: "#399E79", borderWidth: "3px" }}
            ></span>
          )}
        />
      </div>
    </div>
  );
};

export default DealNotesHistory;
